import React from "react";
import "../styles/preloader.css";
import { useTheme } from "./useTheme";

const Loader = () => {
  const isDarkTheme = useTheme();

  return (
    <div className="preloader-overlay">
      <div className="preloader-logo">
        <div className="brand-mark-heartbeat"></div>

        <img
          src={`/img/majesteye-icon-skeye-gate${isDarkTheme ? "-white" : ""}.svg`}
          alt="Skeyegate"
          className="brand-mark-heartbeat"
        />
      </div>
    </div>
  );
};

export default Loader;
